import CashClosingXMovementsSection from "../Payments/CashClosingXMovementsSection";
import PaymentMethodsSection from "../Payments/PaymentMethodsSection";

interface Props {
  report: any;
}

const CashClosingXMain: React.FC<Props> = ({ report }) => {

  if (!report) return null;

  return (
    <div
      className="
        grid grid-cols-1 xl:grid-cols-2
        border-t border-stroke
        dark:border-strokedark
      "
    >

      {/* 💳 MÉTODOS DE PAGO */}
      <div
        className="
          p-5
          xl:border-r border-stroke
          dark:border-strokedark
        "
      >
        <PaymentMethodsSection payments={report.payments} />
      </div>

      {/* 💰 MOVIMIENTOS */}
      <div className="p-5">
        <CashClosingXMovementsSection data={report} />
      </div>

    </div>
  );
};

export default CashClosingXMain;